import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppBody, AppMainLayout } from './Style';
import Header from '../../../features/ThreeJsHtmlExperience/Header';
import Footer from '../../../app/theme/footer';
import CookieConsent from '../../ui/CookieConsent';
import {
  disableAnalytics,
  enableAnalytics,
  readCookieConsent,
  trackPageView,
} from '../../../util/analytics';

export default function Layout() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isHome = /^\/(?:en|fr)?\/?$/.test(location.pathname);
  useEffect(() => {
    const lang =
      location.pathname.split('/').filter(Boolean)[0] === 'fr' ? 'fr' : 'en';
    if ((lang === 'en' || lang === 'fr') && !i18n.language.startsWith(lang))
      i18n.changeLanguage(lang);
    window.scrollTo(0, 0);
  }, [i18n, location.pathname]);
  useEffect(() => {
    if (readCookieConsent()?.analytics) enableAnalytics();
    else disableAnalytics();
  }, []);
  useEffect(() => {
    if (readCookieConsent()?.analytics)
      trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return (
    <AppBody>
      <a className="skip-link" href="#main-content">
        {i18n.language.startsWith('fr')
          ? 'Aller au contenu'
          : 'Skip to content'}
      </a>
      <Header />
      <AppMainLayout>
        <main id="main-content" style={{ width: '100%' }}>
          <Outlet />
        </main>
      </AppMainLayout>
      {!isHome && <Footer />}
      <CookieConsent />
    </AppBody>
  );
}
